import ListaSites from './components/ListaSites'

export default [
  {path: 'sites', component: ListaSites, name: 'sites.lista'}
]
